export default "assets/images/star-58ccba9c.svg";